var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAssistance = function SvgAssistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    fillRule: "evenodd",
    d: "M4.714 7.065c.434-.082.879.055 1.19.367L9.2 10.727a1.083 1.083 0 1 0 1.53-1.531L7.438 5.903a1.333 1.333 0 0 1 .41-2.165 7.956 7.956 0 0 1 11.03 8.588l9.171 9.17a4.633 4.633 0 1 1-6.552 6.553l-9.171-9.171A7.956 7.956 0 0 1 3.74 7.84c.177-.404.541-.695.974-.776m1.027 3.975a5.27 5.27 0 0 0 1.55 3.728 5.28 5.28 0 0 0 5.118 1.366c.46-.123.952.008 1.289.345l9.684 9.684a1.966 1.966 0 1 0 2.78-2.78l-9.683-9.684a1.33 1.33 0 0 1-.345-1.29 5.28 5.28 0 0 0-1.367-5.118 5.27 5.27 0 0 0-3.719-1.55l1.568 1.57a3.75 3.75 0 0 1-5.302 5.302z",
    clipRule: "evenodd"
  })));
};
export default SvgAssistance;